var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-breadcrumb"},[_c('ul',{class:'skin-'+_vm.skin},_vm._l((_vm.detail),function(step,index){return _c('li',{key:index,class:{active:_vm.stepIndex===index+1,
        enabled:index===0&&_vm.stepIndex!==1||index===1&&_vm.stepIndex===3
        },on:{"click":function($event){return _vm.stepChange(index+1)}}},[_c('span',{domProps:{"textContent":_vm._s(step)}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }